/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_ServerInputs */

const de_commons_error_server = /** @type {(inputs: Commons_Error_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.`)
};

/** @type {(inputs: Commons_Error_ServerInputs) => LocalizedString} */
const en_commons_error_server = de_commons_error_server;

/**

* @param {Commons_Error_ServerInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_server = /** @type {((inputs?: Commons_Error_ServerInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_ServerInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_server(inputs)
	return en_commons_error_server(inputs)
});